import { createFileRoute } from '@tanstack/react-router';

import { PatternEditorPage } from '@/pattern-composer/pattern-editor-page';

export const Route = createFileRoute('/pattern-editor/$patternId')({
    component: PatternEditorRoute,
    // The page-level EditorHeaderTray owns both corners on desktop: app nav
    // in its left end, account corner in its right end.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function PatternEditorRoute() {
    const { patternId } = Route.useParams();
    return <PatternEditorPage patternId={patternId} />;
}
